
import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/context/AuthContext';

const navigation = [
  { label: 'Dashboard', path: '/user', icon: '▦', end: true },
  { label: 'Products', path: '/user/products', icon: '□' },
  { label: 'Batches', path: '/user/batches', icon: '▤' },
  { label: 'Invoices', path: '/user/invoices', icon: '▧' },
  { label: 'Stock', path: '/user/stock', icon: '▥' },
];

const UserSidebar = ({ isOpen, onClose }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    onClose();

    try {
      await logout();
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <aside
      className={`user-sidebar ${isOpen ? 'user-sidebar-open' : ''}`}
      aria-label="Distributor navigation"
    >
      <div className="user-sidebar-brand">
        <div className="user-brand-icon">H</div>

        <div className="user-brand-text">
          <strong>HarInventory</strong>
          <span>Distributor Portal</span>
        </div>

        <button
          type="button"
          className="user-sidebar-close"
          aria-label="Close navigation"
          onClick={onClose}
        >
          ×
        </button>
      </div>

      <div className="user-sidebar-section-label">
        WORKSPACE
      </div>

      <nav className="user-sidebar-nav">
        {navigation.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            onClick={onClose}
            className={({ isActive }) =>
              `user-nav-link ${isActive ? 'active' : ''}`
            }
          >
            <span
              className="user-nav-icon"
              aria-hidden="true"
            >
              {item.icon}
            </span>

            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="user-sidebar-bottom">
        <div className="user-sidebar-help">
          <span className="user-help-icon">i</span>

          <div>
            <strong>Inventory workspace</strong>
            <span>Manage your firm in one place.</span>
          </div>
        </div>

        <button
          type="button"
          className="user-logout-button"
          onClick={handleLogout}
        >
          <span aria-hidden="true">↪</span>
          Logout
        </button>
      </div>
    </aside>
  );
};

export default UserSidebar;
